import { ConcreteEncodable } from "./ConcreteEncodable";

import { AutoHedgingStatusEventImplEncoder } from "../../encoder/AutoHedgingStatusEventImplEncoder";

import * as CubiqTS from "../../index";
import { AutoHedgingStatusEvent } from "../AutoHedgingStatusEvent";

export class AutoHedgingStatusEventImpl
  extends ConcreteEncodable
  implements AutoHedgingStatusEvent
{
  public static enType: string = "com.bcdfx.model.event.lifecycle.AutoHedgingStatusEventImpl";

  /*FID=1*/
  public status: CubiqTS.AutoHedgingStatus | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = AutoHedgingStatusEventImplEncoder.Instance;
    this.setEncodableType(AutoHedgingStatusEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "AutoHedgingStatusEventImpl[" + "status=" + this.status + "messageId=" + this.messageId + "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
